import { useEffect } from 'react';
import { useMedicamentosIniciadoAutorizadoData } from '../hooks';
import { IniciadoAutorizadoTotalesSection } from './IniciadoAutorizadoTotalesSection';
import { IniciadoAutorizadoSection } from './IniciadoAutorizadoSection';

const initData = {
  // idDivision: 5,
  // idTipoCobertura: 166,
};

export const MedicamentosTramitesIniciadoAutorizado = () => {
  const { getMedicamentosTramitesAnualList, getMedicamentosTramitesMensualList } =
    useMedicamentosIniciadoAutorizadoData({
      ...initData,
    });

  useEffect(() => {
    getMedicamentosTramitesAnualList();
    getMedicamentosTramitesMensualList();
  }, []);

  return (
    <>
      <IniciadoAutorizadoTotalesSection />
      <IniciadoAutorizadoSection />
    </>
  );
};
